import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PrivateAxios } from "../../apiEcommerce";

const initialState = {
  getUser: [],
  status: 'idle',
  updateStatus: 'idle',
  error: null,
};

// Get Profile
export const fetchUser = createAsyncThunk(
  'getUser/fetchUser',
  async (_, { rejectWithValue }) => {
    try {
      const response = await PrivateAxios.get(
        '/api/ecomerce/user/getProfile'
      );
      return response.data.data.user;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

// Update Profile
export const updateProfile = createAsyncThunk(
  'getUser/updateProfile',
  async (data, { rejectWithValue }) => {
    try {
      const response = await PrivateAxios.post(
        '/api/ecomerce/user/updateProfile',
        data
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const getUserSlice = createSlice({
  name: 'getUser',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Get Profile
      .addCase(fetchUser.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.getUser = action.payload;
      })
      .addCase(fetchUser.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      })

      // Update Profile
      .addCase(updateProfile.pending, (state) => {
        state.updateStatus = 'loading';
        state.error = null;
      })
      .addCase(updateProfile.fulfilled, (state) => {
        state.updateStatus = 'succeeded';
      })
      .addCase(updateProfile.rejected, (state, action) => {
        state.updateStatus = 'failed';
        state.error = action.payload || action.error.message;
      });
  },
});

export default getUserSlice.reducer;
